import queryString from "query-string";
import parseSearchQuery from "./parseSearchQuery";

const _cleanObject = (obj) => {
    const newObject = {};
    const object = {...obj};

    for (let propName in object) {
        if (!obj[propName]) {
            continue;
        }

        newObject[propName] = obj[propName];
    }

    return newObject;
};

export default (history) => (query) => {
    const parsed = parseSearchQuery(history);
    const changed = Object.assign(parsed, query);
    const clean = _cleanObject(changed);

    history.replace({
        search: queryString.stringify(clean)
    });
};



// WEBPACK FOOTER //
// ./src/helpers/routes/changeQuerySearch.js